import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CustomerRow,
    WB_ModelCompareRelationshipRow,
    WB_ModelCompareRow,
    WB_ModelingSessionRow,
    WB_ModelRow,
    WB_ModelingSessionProdRRow,
    WB_ProductGroupRow,
    WB_FinishedProductRow, WB_ProductHierarchyLevelRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbModelCompare,} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Model_Compare,
    esWB_Model_Compare_Relationship,
    esWB_Modeling_Session,
    esWB_Modeling_Session_Coeff_Grp,
    esWB_Modeling_Session_El,
    esWB_Modeling_Session_ConstantR,
    esWB_Modeling_Session_ConstantFR,
    esWB_Modeling_Session_Trial,
    esWB_Modeling_Session_Range,
    esWB_Modeling_Session_Trial_Metric,
    esWB_Model,
    esWB_Model_Coefficient,
    esWB_Model_Term_Relationship,
    esWB_Modeling_Session_AffinitySet_Relationship,
    esWB_Modeling_Session_Coeff_Rule,
    esWB_Modeling_Session_Observation,
    esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship,
    esWB_Modeling_Session_Tag_RuleR,
    esWB_Modeling_Session_Reference_Predictor_Relationship,
    esWB_Modeling_Session_Log,
    esWB_Modeling_Session_ElCR,
    esWB_Modeling_Session_ElR,
    esWB_Modeling_Session_Cannibalization_Type_Relationship,
    esWB_Model_Cannibalization_Relationship,
    esWB_Model_Predictor,
    esWB_Customer_Hierarchy,
    esWB_Product_Hierarchy,
    esWB_Period_Hierarchy,
    esWB_Period_Type,
    esWB_Modeling_Session_TermR,
    esWB_Modeling_Session_Reference_Relationship,
    esWB_Model_Function,
    esWB_Product_Group,
    esWB_Product_Type, esWB_Product_Hierarchy_Level, esWB_Model_Tag_Relationship
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {BehaviorSubject} from "rxjs";
import {IModelCompareSessionChangedEvent, IModelCompareSessions} from "../PA.Model.Core/PA.Model.IF.Aspects";
import {ProductHierarchyService} from "../PA.MD.Services/ProductHierarchyService";
import {ModelingScorecardService} from "../PA.Model.Services/ModelingScorecardService";
import {DateUtils} from "../PA.Core/Basic/Dates";


export class ModelScorecardBO implements IBusinessObject,
    IModelCompareSessions {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ModelScorecard: WB_ModelCompareRow;

    _ModelingSessionsChanged: BehaviorSubject<ModelScorecardBO>

    _dctCustomerRowLoadedById: { [id: number]: WB_CustomerRow }
    _dctPrdGrpRowLoadedById:  WB_ProductGroupRow []
    _dctPrdRowLoadedById:  WB_FinishedProductRow[]
    _dctAllCustomerRowsLoadedById: WB_CustomerRow[]
    _dctAllPrdGrpRowsLoadedById:  WB_ProductGroupRow []
    _dctAllPrdRowsLoadedById: WB_FinishedProductRow[]
    _ProductCountKPI: number

    _dctProductLevels: any[]

    _ModelingScorecardService: ModelingScorecardService

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Model Scorecard'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_ModelScorecard = null;

        this._ModelingSessionsChanged = new BehaviorSubject<ModelScorecardBO>(undefined)
        this._dctPrdGrpRowLoadedById = []
        this._dctCustomerRowLoadedById = {}
        this._dctPrdRowLoadedById = []
        this._dctAllCustomerRowsLoadedById = []
        this._dctAllPrdGrpRowsLoadedById = []
        this._dctAllPrdRowsLoadedById = []
        this._ProductCountKPI = 0

        this._ModelingScorecardService = new ModelingScorecardService()

        this.IModelCompareSessions_init()
    }

    get WB_ModelScorecard(): WB_ModelCompareRow {
        return this.drWB_ModelScorecard;
    }

    get PrimaryModelingSession(): WB_ModelCompareRelationshipRow {
        return _.first(_.filter(this.WB_ModelScorecard.WB_ModelCompareRRows, aRow => aRow.isActive && aRow.cif.PRIMARY_IND == '1'))
    }

    get PrimaryProductGroups(): WB_ProductGroupRow[] {
        return _.values(this._dctPrdGrpRowLoadedById)
    }

    get PrimaryProducts(): WB_FinishedProductRow[] {
        return _.values(this._dctPrdRowLoadedById)
    }

    get PrimaryCustomers(): WB_CustomerRow[] {
        return _.values(this._dctCustomerRowLoadedById)
    }

    get AllCustomers(): WB_CustomerRow[]{
        return _.values(this._dctAllCustomerRowsLoadedById)
    }
    get AllProducts(): WB_FinishedProductRow[]{
        return _.values(this._dctAllPrdRowsLoadedById)
    }
    get AllProductGroups(): WB_ProductGroupRow[]{
        return _.values(this._dctAllPrdGrpRowsLoadedById)
    }

    get ProductCountKPI(): number{
        return this._ProductCountKPI
    }

    get ModelScorecardService(): ModelingScorecardService {
        return this._ModelingScorecardService
    }

    //<editor-fold desc = "IBusinessObject operations">
    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating Model Compare");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for new Published Model.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            this.dbContext.createRecordWithKey(esWB_Model_Compare)
                .then((newModelCompareRow: WB_ModelCompareRow) => {
                    newModelCompareRow.setDefaults();
                    newModelCompareRow.cif.COMPARE_TYPE = "Scorecard"
                    self.drWB_ModelScorecard = newModelCompareRow;
                    // self.drWB_ModelScorecard.cif.COMPARE_TYPE = "Scorecard"
                    self.dbContext.add(esWB_Model_Compare, newModelCompareRow);
                    self.Identity.setAll(self.WB_ModelScorecard.cif.WB_MODELCOMPARE_ID, self.WB_ModelScorecard.cif.MODEL_COMPARE_ID, self.WB_ModelScorecard.cif.MODEL_COMPARE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_ModelScorecard, 'WB_MODELCOMPARE_ID', 'MODEL_COMPARE_ID', 'MODEL_COMPARE_NAME');
                    self.Identity.enableRecordWriteBack(self.WB_ModelScorecard,undefined,'MODEL_COMPARE_NAME')
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })
        });

        return this._OnLoadComplete;
    }

    async Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = (async () => {
            try {

            if (self.bIsLoaded) {
                let sError = "Model Compare already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                return this;
            }

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                let sError = "Unable to determine dbContext for Model Compare.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                return this;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = ModelScorecardBO.createRecordResolver({dbContext: self.dbContext});
                recordResolverLoadPromise = ModelScorecardBO.setupRecordResolver(recordResolver, [anId])
            }

            await recordResolverLoadPromise

                    let newModelCompareRow: any = recordResolver.get(esWB_Model_Compare, anId);

                    if (_.isEmpty(newModelCompareRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");

                        return self;
                    }

                    self.drWB_ModelScorecard = newModelCompareRow;
                    self.Identity.setAll(self.WB_ModelScorecard.cif.WB_MODELCOMPARE_ID, self.WB_ModelScorecard.cif.MODEL_COMPARE_ID, self.WB_ModelScorecard.cif.MODEL_COMPARE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_ModelScorecard, 'WB_MODELCOMPARE_ID', 'MODEL_COMPARE_ID', 'MODEL_COMPARE_NAME');
                    self.Identity.enableRecordWriteBack(self.WB_ModelScorecard,undefined,'MODEL_COMPARE_NAME')

                    await self.setScope(-1)

                    await self.setScopeOnLoadComplete()
                    await self.productCount()
                    await self.IModelCompareSessions_OnLoadComplete()

                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                   return self
                }
                catch(err: any)  {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
            return self;
                };

        })();

        return self._OnLoadComplete;
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        if (this._bIsLoaded) {
            return ASync.resolve(this)
        }
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {

        let self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_ModelScorecard.cif.MODEL_COMPARE_NAME + "(" + self.WB_ModelScorecard.cif.MODEL_COMPARE_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                let sError = "Unable to determine dbContext to Validate Model Compare.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        const wbModelCompare = <IwbModelCompare>self.drWB_ModelScorecard;
        this.SaveProgressProvider.start("Saving " + wbModelCompare.MODEL_COMPARE_NAME + "(" + wbModelCompare.MODEL_COMPARE_ID + ")");

        self.drWB_ModelScorecard.cif.COMPARE_TYPE = "Scorecard"
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // We could search the tree if there is any record where store isn't set.

            if (self.dbContext == null) {
                self._bIsSaved = false;
                let sError = "Unable to determine dbContext to Save Model Scorecard.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }

            self.SaveOptions = options || {};

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }

            saveFunction(esWB_Model_Compare, self.drWB_ModelScorecard, {})
                .then((ignored) => {
                    let tasks: Promise<any>[] = [];

                    tasks.push(saveFunction(esWB_Model_Compare, self.drWB_ModelScorecard));
                    tasks.push(saveFunction(esWB_Model_Compare_Relationship, self.drWB_ModelScorecard.WB_ModelCompareRRows));
                    return Promise.all(tasks);
                })
                .then((ignored) => {
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(() => {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    reject(self);
                })
        })
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbModelCompare = <IwbModelCompare>self.drWB_ModelScorecard;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbModelCompare.MODEL_COMPARE_NAME + "(" + wbModelCompare.MODEL_COMPARE_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Customer

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ModelScorecard.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }


//<editor-fold desc = "Modeling Session operations">
    _ModelCompareSessionCollectionChanged: BehaviorSubject<IModelCompareSessions>;
    _ModelCompareSessionPropertyChanged: BehaviorSubject<IModelCompareSessionChangedEvent>;

    IModelCompareSessions_init(): void {

        this._ModelCompareSessionCollectionChanged = new BehaviorSubject<IModelCompareSessions>(undefined);
        this._ModelCompareSessionPropertyChanged = new BehaviorSubject<IModelCompareSessionChangedEvent>(undefined);

    }

    private IModelCompareSessions_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            _.forEach(self.WB_ModelScorecard.WB_ModelCompareRRows, (aRow) => {
                aRow.setupOnChangeEvents([], self.IModelCompareSession_onRecordChange.bind(self), self)
            })
            resolve()
        })
    }


    private IModelCompareSession_onRecordChange(record: WB_ModelCompareRelationshipRow, propertyName: string, propertyValue: any, options: ModelScorecardBO) {
        // this.ModelCompareSessionPropertyChanged.next({
        //     ModelCompareBO: options,
        //     Row: record,
        //     PropertyChanged: propertyName,
        //     PropertyValue: propertyValue
        // })
    }

    get ModelCompareSessionPropertyChanged(): BehaviorSubject<IModelCompareSessionChangedEvent> {
        return this._ModelCompareSessionPropertyChanged
    }


    get ModelingSessionsChanged(): BehaviorSubject<IModelCompareSessions> {
        return this._ModelCompareSessionCollectionChanged
    }

    get ProductLevels(): any[] {
        return this._dctProductLevels
    }

    async addModelingSession(aWB_Id: number, options?: any): Promise<WB_ModelCompareRelationshipRow> {
        const self = this;


        let recordResolver = ModelScorecardBO.createModelingSessionRecordResolver({dbContext: self.dbContext})

        let query: any = {WB_MODELING_SESSION_ID: aWB_Id}
        let arrModelingSession: WB_ModelingSessionRow[] = <WB_ModelingSessionRow[]>await recordResolver.queryAllWithRelationships(esWB_Modeling_Session, query)

        if (_.isEmpty(arrModelingSession))
            return

        let aMSRecord = _.first(arrModelingSession)

        let aNewRow: WB_ModelCompareRelationshipRow = <any>await self.dbContext.createRecordWithKey(esWB_Model_Compare_Relationship)
        let defaultColor = _.first(_.difference(['#e6194B', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#42d4f4', '#f032e6', '#fabed4', '#469990', '#dcbeff', '#9A6324', '#fffac8', '#800000', '#aaffc3', '#000075', '#a9a9a9', '#ffffff', '#000000'], _.map(_.filter(self.drWB_ModelScorecard.WB_ModelCompareRRows, aRow => aRow.isActive), 'PLOT_DATA_COLOR')))
        aNewRow.setDefaults()
        aNewRow.cif.WB_MODELCOMPARE_ID = self.drWB_ModelScorecard.cif.WB_MODELCOMPARE_ID;
        aNewRow.cif.WB_MODELING_SESSION_ID = aWB_Id
        aNewRow.cif.PRIMARY_IND = (options.bPrimary) ? '1' : '0'
        aNewRow.cif.PLOT_DATA_COLOR = defaultColor

        aNewRow.WB_ModelingSessionRow = aMSRecord
        aNewRow.setupOnChangeEvents([], self.IModelCompareSession_onRecordChange.bind(self), self)

        self.dbContext.add(esWB_Model_Compare_Relationship, aNewRow)

        if (options.bPrimary)
            await self.setScope(aWB_Id)

        self.ModelingSessionsChanged.next(self)
        await self.refreshScope()
        return (aNewRow)

    }

    removeModelingSession(aWB_MODELCOMPARER_IDs: number[], options?: any): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            let keyByIds = _.keyBy(aWB_MODELCOMPARER_IDs, anId => anId)

            _.forEach(self.drWB_ModelScorecard.WB_ModelCompareRRows, (aRow: WB_ModelCompareRelationshipRow) => {
                if (aRow.isActive && (aRow.cif.WB_MODELCOMPARER_ID in keyByIds)) {
                    aRow.markDeleted()
                }
            })

            //check if the primary modeling session has been deleted -> if yes -> make that primary and reset the scope

            let activeModelRRows: WB_ModelCompareRelationshipRow[] = _.filter(self.drWB_ModelScorecard.WB_ModelCompareRRows,
                (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive)
            let modelCompareR: WB_ModelCompareRelationshipRow = _.first(_.filter(activeModelRRows,
                (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive && aRow.cif.PRIMARY_IND == '1'))
            if (_.isUndefined(modelCompareR) && activeModelRRows.length > 0) {
                activeModelRRows[0].cif.PRIMARY_IND = '1'
            }



            self.setScope(-1)
                .then(() => {
                    self.ModelingSessionsChanged.next(self)
                    self.refreshScope()
                    resolve()
                })
                .catch((err) => {
                    console.log(err)
                    resolve()
                })
        })

    }

    setScope(aWBId: number): Promise<void> {
        const self = this;

        return new Promise<void>(async (resolve, error) => {
                try {
                    if (aWBId == -1) {
                        //fetch the primary modeling session

                        let modelCompareR: WB_ModelCompareRelationshipRow = _.first(_.filter(self.drWB_ModelScorecard.WB_ModelCompareRRows,
                            (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive && aRow.cif.PRIMARY_IND == '1'))

                        if (_.isUndefined(modelCompareR)) {
                            resolve()
                            return
                        } else
                            aWBId = modelCompareR.cif.WB_MODELING_SESSION_ID
                    }

                    let recordResolver = ModelScorecardBO.createModelingSessionRecordResolver({dbContext: self.dbContext})
                    let query: any = {WB_MODELING_SESSION_ID: aWBId}
                    let arrModelingSession: WB_ModelingSessionRow[] = <WB_ModelingSessionRow[]>await recordResolver.queryAllWithRelationships(esWB_Modeling_Session, query)

                    let primaryRecord: WB_ModelingSessionRow = arrModelingSession[0]
                    let modelRow: WB_ModelRow = primaryRecord.WB_ModelRow

                    //set model resolution
                    self.WB_ModelScorecard.cif.WB_ENTITY_ID_PERIOD = primaryRecord.cif.WB_ENTITY_ID_PERIOD
                    self.WB_ModelScorecard.cif.WB_ENTITY_ID_CUSTOMER = primaryRecord.cif.WB_ENTITY_ID_CUSTOMER
                    self.WB_ModelScorecard.cif.WB_ENTITY_ID_PRODUCT = primaryRecord.cif.WB_ENTITY_ID_PRODUCT
                    self.WB_ModelScorecard.cif.WB_SALESORG_ID = primaryRecord.cif.WB_SALESORG_ID

                    if (primaryRecord.cif.WB_CUSTH_ID != self.WB_ModelScorecard.cif.WB_CUSTH_ID) {
                        let custHRow = await self.dbContext.find(esWB_Customer_Hierarchy, primaryRecord.cif.WB_CUSTH_ID)
                        self.WB_ModelScorecard.WB_CustomerHierarchyRow = custHRow
                        self.WB_ModelScorecard.cif.WB_CUSTH_ID = primaryRecord.cif.WB_CUSTH_ID
                    }

                    if (primaryRecord.cif.WB_PRDH_ID != self.WB_ModelScorecard.cif.WB_PRDH_ID) {
                        let prodHRow = await self.dbContext.find(esWB_Product_Hierarchy, primaryRecord.cif.WB_PRDH_ID)
                        self.WB_ModelScorecard.WB_ProductHierarchyRow = prodHRow
                        self.WB_ModelScorecard.cif.WB_PRDH_ID = primaryRecord.cif.WB_PRDH_ID
                    }

                    if (primaryRecord.cif.WB_PERIODH_ID != self.WB_ModelScorecard.cif.WB_PERIODH_ID) {
                        let periodHRow = await self.dbContext.find(esWB_Period_Hierarchy, primaryRecord.cif.WB_PERIODH_ID)
                        self.WB_ModelScorecard.WB_PeriodHierarchyRow = periodHRow
                        self.WB_ModelScorecard.cif.WB_PERIODH_ID = primaryRecord.cif.WB_PERIODH_ID
                    }

                    //set the dates
                    self.WB_ModelScorecard.cif.START_DT = primaryRecord.cif.START_DT
                    self.WB_ModelScorecard.cif.END_DT = primaryRecord.cif.END_DT
                    self.WB_ModelScorecard.cif.HOLDOUT_START_DT = primaryRecord.cif.HOLDOUT_START_DT
                    self.WB_ModelScorecard.cif.HOLDOUT_END_DT = primaryRecord.cif.HOLDOUT_END_DT

                    //set Primary products or productGroups  - depending on the model product type
                    if (modelRow.cif.PRODUCT_TYPE == "Product") {
                        let arrProducts: WB_FinishedProductRow[] = _.map(
                            _.filter(primaryRecord.WB_ModelingSessionProdRRows, (aRow: WB_ModelingSessionProdRRow) => aRow.isActive),
                            (aProdRRow: WB_ModelingSessionProdRRow) => aProdRRow.WB_ProductRow)
                        self._dctPrdRowLoadedById = arrProducts
                    } else {
                        let arrProductGrps: WB_ProductGroupRow[] = _.map(
                            _.filter(primaryRecord.WB_ModelingSessionProdRRows, (aRow: WB_ModelingSessionProdRRow) => aRow.isActive),
                            (aProdRRow: WB_ModelingSessionProdRRow) => aProdRRow.WB_ProductGroupRow)
                        self._dctPrdGrpRowLoadedById = arrProductGrps
                    }

                    resolve()
                } catch (err) {
                    error(err)
                }
            }
        )
    }

    async setScopeOnLoadComplete(): Promise<void>{
        const self =this
        let recordResolver = ModelScorecardBO.createModelingSessionRecordResolver({dbContext: self.dbContext})

        let modelCompareRs: WB_ModelCompareRelationshipRow[] = _.filter(self.drWB_ModelScorecard?.WB_ModelCompareRRows,
            (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive)
        let allModelingSessionsIds = modelCompareRs.length > 0 && _.map(modelCompareRs,'WB_MODELING_SESSION_ID')

        let aRecordResolver = new ESRecordResolver(self.dbContext,
            {
                dctExcludeHasManyNamedRelations: {
                    [esWB_Modeling_Session]: [
                        esWB_Modeling_Session_El, esWB_Modeling_Session_Coeff_Grp, esWB_Modeling_Session_ConstantR,
                        esWB_Modeling_Session_ConstantFR, esWB_Modeling_Session_Trial, esWB_Modeling_Session_Range, esWB_Modeling_Session_Trial_Metric,
                        esWB_Modeling_Session_AffinitySet_Relationship, esWB_Modeling_Session_Coeff_Rule, esWB_Modeling_Session_Observation,
                        esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship, esWB_Modeling_Session_Tag_RuleR, esWB_Modeling_Session_Reference_Predictor_Relationship,
                        esWB_Modeling_Session_Log, esWB_Modeling_Session_ElCR, esWB_Modeling_Session_ElR, esWB_Modeling_Session_Cannibalization_Type_Relationship,
                        esWB_Modeling_Session_TermR, esWB_Modeling_Session_Reference_Relationship
                    ],
                    [esWB_Model]: [esWB_Model_Coefficient, esWB_Model_Term_Relationship, esWB_Model_Cannibalization_Relationship, esWB_Model_Predictor, esWB_Model_Function]
                }
            })
        let queryAll: any = {WB_MODELING_SESSION_ID: {inq : allModelingSessionsIds || [0]}}
        let arrAllModelingSession: WB_ModelingSessionRow[] = <WB_ModelingSessionRow[]>await recordResolver.queryAllWithRelationships(esWB_Modeling_Session,queryAll)//recordResolver.queryAllWithRelationships(esWB_Modeling_Session, queryAll)
        self.setCustProdPPGScope(arrAllModelingSession)

    }


    async refreshScope():  Promise<void>{
        const self =this

        // get all modeling sessions
        let modelCompareRs: WB_ModelCompareRelationshipRow[] = _.filter(self.drWB_ModelScorecard?.WB_ModelCompareRRows,
            (aRow: WB_ModelCompareRelationshipRow) => aRow.isActive)
        let allModelingSessionsIds = modelCompareRs.length > 0 && _.map(modelCompareRs,'WB_MODELING_SESSION_ID')

        let queryAll: any = {WB_MODELING_SESSION_ID: {inq : allModelingSessionsIds || [0]}}
        let arrAllModelingSession: WB_ModelingSessionRow[] = <WB_ModelingSessionRow[]>await self.dbContext.findAll(esWB_Modeling_Session,{where: queryAll})//recordResolver.queryAllWithRelationships(esWB_Modeling_Session, queryAll)

        self.setCustProdPPGScope(arrAllModelingSession)
        await self.productCount()

    }

    setCustProdPPGScope(arrAllModelingSession: WB_ModelingSessionRow[]): void{
        const self =this

        let arrAllCustomers: WB_CustomerRow[] = []
        let arrAllProducts: WB_FinishedProductRow[] = []
        let arrAllProductGroups: WB_ProductGroupRow[] = []
        if(!_.isEmpty(arrAllModelingSession))
            _.forEach(arrAllModelingSession, aRow=>{
                _.forEach(aRow?.WB_ModelingSessionCustRRows, relRow =>{
                    if(relRow.isActive){
                        arrAllCustomers.push(relRow.WB_CustomerRow)
                    }
                })
                if(aRow?.WB_ModelRow?.cif.PRODUCT_TYPE==='Product'){
                    _.forEach(aRow.WB_ModelingSessionProdRRows, relRow =>{
                        if(relRow.isActive ){
                            arrAllProducts.push(relRow.WB_ProductRow)
                        }
                    })
                }
                else{
                    _.forEach(aRow?.WB_ModelingSessionProdRRows, relRow =>{
                        if(relRow.isActive){
                            arrAllProductGroups.push(relRow.WB_ProductGroupRow)
                        }
                    })
                }
            })
        arrAllCustomers = _.sortBy(_.uniq(arrAllCustomers),'CUSTOMER_NAME')
        self._dctAllCustomerRowsLoadedById = arrAllCustomers
        arrAllProducts = _.sortBy(_.uniq(arrAllProducts),'PRODUCT_NAME')
        arrAllProductGroups = _.sortBy(_.uniq(arrAllProductGroups),'PRODUCT_GROUP_NAME')
        self._dctAllPrdRowsLoadedById = arrAllProducts
        self._dctAllPrdGrpRowsLoadedById = arrAllProductGroups
    }


    async productCount(): Promise<void>{
        const self = this
        let productNodes: any[] = []
        let allLevelIDs: WB_ProductHierarchyLevelRow[] = await self.dbContext.findAll(esWB_Product_Hierarchy_Level,{where: {DELETED_IND: {neq: '1'}, WB_PRDH_ID: self.WB_ModelScorecard.cif.WB_PRDH_ID} })
        self._dctProductLevels = _.map(allLevelIDs, aLevel => {
            let aLvl = {
                "LEVEL_NAME": aLevel.cif.LEVEL_NAME,
                "LEVEL_ID": aLevel.cif.LEVEL_ID
            }
            return aLvl
        })
    }


    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const modelCompare_options: CreateOptions = {
            standardConditions: {},
            dctIncludeBelongsToNamedRelations: {

    }
        };

        const aRecResolver = new ESRecordResolver(dbContext, modelCompare_options);

        return aRecResolver;
    }


    static createModelingSessionRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const modelingSession_options: CreateOptions = {
            standardConditions: {},
            dctExcludeHasManyNamedRelations: {
                [esWB_Modeling_Session]: [
                    esWB_Modeling_Session_El, esWB_Modeling_Session_Coeff_Grp, esWB_Modeling_Session_ConstantR,
                    esWB_Modeling_Session_ConstantFR, esWB_Modeling_Session_Trial, esWB_Modeling_Session_Range, esWB_Modeling_Session_Trial_Metric,
                    esWB_Modeling_Session_AffinitySet_Relationship, esWB_Modeling_Session_Coeff_Rule, esWB_Modeling_Session_Observation,
                    esWB_Modeling_Session_Cannibalization_Power_Metric_Relationship, esWB_Modeling_Session_Tag_RuleR, esWB_Modeling_Session_Reference_Predictor_Relationship,
                    esWB_Modeling_Session_Log, esWB_Modeling_Session_ElCR, esWB_Modeling_Session_ElR, esWB_Modeling_Session_Cannibalization_Type_Relationship,
                    esWB_Modeling_Session_TermR, esWB_Modeling_Session_Reference_Relationship
                ],
                [esWB_Model]: [esWB_Model_Coefficient, esWB_Model_Term_Relationship, esWB_Model_Cannibalization_Relationship, esWB_Model_Predictor, esWB_Model_Function]
            }
        };

        const aRecResolver = new ESRecordResolver(dbContext, modelingSession_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_Model_Compare, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>
}

PAEnvironment.registerBusinessObjectClass(ModelScorecardBO, "ModelScorecardBO", "Model Scorecard")
